import { FormStepId } from 'shared/config/formStepId';

export const STEPS_TO_CHECK = [FormStepId.CreditPurposeInfo, FormStepId.ContactsInfo, FormStepId.PassportInfo];
